import { User } from "@/types/user";
import axios, { AxiosResponse } from "axios";
import { Component, Vue } from "vue-property-decorator";

@Component
export class UserHttp extends Vue {
	public deleteCurrentAccount(): Promise<AxiosResponse<any>> {
		return axios.delete(process.env.VUE_APP_API_ENDPOINT + "/users/me", {
			headers: {
				authorization: "Bearer " + localStorage.getItem("access_token"),
			},
		});
	}

	public changePassword(newPassword: string): Promise<AxiosResponse<any>> {
		return axios.put(
			process.env.VUE_APP_API_ENDPOINT + "/users/me/change-password",
			{ password: newPassword },
			{
				headers: {
					authorization: "Bearer " + localStorage.getItem("access_token"),
				},
			}
		);
	}

	public getAllUsers(): Promise<any> {
		return axios.get(process.env.VUE_APP_API_ENDPOINT + "/admin/users", {
			headers: {
				authorization: "Bearer " + localStorage.getItem("access_token"),
			},
		});
	}

	public changeUserRole(userId: string, newRole: string): Promise<any> {
		return axios.put(
			process.env.VUE_APP_API_ENDPOINT + "/admin/users/" + userId,
			{
				roleName: newRole,
			},
			{
				headers: {
					authorization: "Bearer " + localStorage.getItem("access_token"),
				},
			}
		);
	}

	public deleteUserById(userId: string): Promise<any> {
		return axios.delete(process.env.VUE_APP_API_ENDPOINT + "/admin/users/" + userId, {
			headers: {
				authorization: "Bearer " + localStorage.getItem("access_token"),
			},
		});
	}

	public updateUserById(userId: string, updates: any): Promise<any> {
		return axios.put(process.env.VUE_APP_API_ENDPOINT + "/admin/users/" + userId, updates, {
			headers: {
				authorization: "Bearer " + localStorage.getItem("access_token"),
			},
		});
	}
}
